var _excluded = ["actionText"];

function cov_gan9kb495() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Toast/Toast.tsx";
  var hash = "b599666ec0d6ba6da9f4743a81da94c4f868b888";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Toast/Toast.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 54
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 38,
          column: 24
        },
        end: {
          line: 57,
          column: 1
        }
      },
      "2": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 50
        }
      },
      "3": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 56,
          column: 4
        }
      },
      "4": {
        start: {
          line: 59,
          column: 71
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "5": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 75,
          column: 11
        }
      },
      "6": {
        start: {
          line: 94,
          column: 25
        },
        end: {
          line: 169,
          column: 1
        }
      },
      "7": {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 25
        }
      },
      "8": {
        start: {
          line: 106,
          column: 17
        },
        end: {
          line: 115,
          column: 3
        }
      },
      "9": {
        start: {
          line: 109,
          column: 45
        },
        end: {
          line: 109,
          column: 88
        }
      },
      "10": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 58
        }
      },
      "11": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 114,
          column: 5
        }
      },
      "12": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 26
        }
      },
      "13": {
        start: {
          line: 117,
          column: 37
        },
        end: {
          line: 120,
          column: 3
        }
      },
      "14": {
        start: {
          line: 122,
          column: 2
        },
        end: {
          line: 168,
          column: 4
        }
      },
      "15": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 149,
          column: 9
        }
      },
      "16": {
        start: {
          line: 129,
          column: 14
        },
        end: {
          line: 138,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 24
          },
          end: {
            line: 38,
            column: 25
          }
        },
        loc: {
          start: {
            line: 38,
            column: 30
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 38
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 59,
            column: 71
          },
          end: {
            line: 59,
            column: 72
          }
        },
        loc: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 75,
            column: 11
          }
        },
        line: 63
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 94,
            column: 25
          },
          end: {
            line: 94,
            column: 26
          }
        },
        loc: {
          start: {
            line: 103,
            column: 5
          },
          end: {
            line: 169,
            column: 1
          }
        },
        line: 103
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 106,
            column: 17
          },
          end: {
            line: 106,
            column: 18
          }
        },
        loc: {
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 106
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 5
          }
        },
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 149,
            column: 9
          }
        },
        line: 124
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 128,
            column: 32
          },
          end: {
            line: 128,
            column: 33
          }
        },
        loc: {
          start: {
            line: 129,
            column: 14
          },
          end: {
            line: 138,
            column: 16
          }
        },
        line: 129
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 22
          },
          end: {
            line: 50,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 34
          },
          end: {
            line: 50,
            column: 51
          }
        }, {
          start: {
            line: 50,
            column: 54
          },
          end: {
            line: 50,
            column: 59
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 109,
            column: 45
          },
          end: {
            line: 109,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 45
          },
          end: {
            line: 109,
            column: 52
          }
        }, {
          start: {
            line: 109,
            column: 56
          },
          end: {
            line: 109,
            column: 88
          }
        }],
        line: 109
      },
      "2": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 18
          }
        }, {
          start: {
            line: 111,
            column: 22
          },
          end: {
            line: 111,
            column: 58
          }
        }],
        line: 111
      },
      "3": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 112
      },
      "4": {
        loc: {
          start: {
            line: 119,
            column: 15
          },
          end: {
            line: 119,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 15
          },
          end: {
            line: 119,
            column: 47
          }
        }, {
          start: {
            line: 119,
            column: 51
          },
          end: {
            line: 119,
            column: 56
          }
        }],
        line: 119
      },
      "5": {
        loc: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 139,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 27
          }
        }, {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 139,
            column: 14
          }
        }],
        line: 127
      },
      "6": {
        loc: {
          start: {
            line: 140,
            column: 11
          },
          end: {
            line: 147,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 11
          },
          end: {
            line: 140,
            column: 34
          }
        }, {
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 146,
            column: 14
          }
        }],
        line: 140
      },
      "7": {
        loc: {
          start: {
            line: 145,
            column: 26
          },
          end: {
            line: 145,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 57
          },
          end: {
            line: 145,
            column: 83
          }
        }, {
          start: {
            line: 145,
            column: 86
          },
          end: {
            line: 145,
            column: 88
          }
        }],
        line: 145
      },
      "8": {
        loc: {
          start: {
            line: 154,
            column: 25
          },
          end: {
            line: 154,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 43
          },
          end: {
            line: 154,
            column: 61
          }
        }, {
          start: {
            line: 154,
            column: 64
          },
          end: {
            line: 154,
            column: 76
          }
        }],
        line: 154
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b599666ec0d6ba6da9f4743a81da94c4f868b888"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gan9kb495 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_gan9kb495();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { colors, fonts, fontSizesNamedWithUnits, fontWeights, lineHeightsWithUnits, radii, shadows, spaceWithUnits } from '../../theme/eero';
import { Flex } from '../../core';
import Button from '../../core/Button';
import useMedia from '../../hooks/useMedia';
export var defaultToastStyle = (cov_gan9kb495().s[0]++, {
  backgroundColor: colors.neutrals100,
  boxShadow: shadows.z2,
  color: colors.neutrals0,
  fontFamily: fonts.sans,
  fontSize: fontSizesNamedWithUnits.s1,
  fontWeight: fontWeights.normal,
  lineHeight: lineHeightsWithUnits.s1
}); // make sure this component is mounted once and only once at app root before calling `showToast`

cov_gan9kb495().s[1]++;

var Toast = function Toast() {
  cov_gan9kb495().f[0]++;
  var isDesktop = (cov_gan9kb495().s[2]++, useMedia('(min-width: 645px)'));
  cov_gan9kb495().s[3]++;
  return /*#__PURE__*/React.createElement(ToastContainer, {
    autoClose: 5000,
    bodyStyle: {
      display: 'block',
      padding: 0
    },
    hideProgressBar: true,
    pauseOnHover: true,
    position: "top-center",
    style: {
      maxWidth: '100%',
      width: '645px',
      borderRadius: isDesktop ? (cov_gan9kb495().b[0][0]++, radii.semiRounded) : (cov_gan9kb495().b[0][1]++, '0px'),
      overflow: 'hidden',
      padding: 0
    },
    transition: Slide
  });
};

cov_gan9kb495().s[4]++;

var ToastButton = function ToastButton(_ref) {
  var actionText = _ref.actionText,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_gan9kb495().f[1]++;
  cov_gan9kb495().s[5]++;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "link",
    size: "sm",
    width: "initial",
    color: "neutrals0",
    fontSize: "s0",
    fontWeight: "semibold",
    pl: 3,
    pr: 3
  }, props), actionText);
}; // type of the `options` prop to be passed to `showToast`


cov_gan9kb495().s[6]++;
// call this function to render the toast
export var showToast = function showToast(type, content, analyticsName, options) {
  var _options$toastOptions;

  cov_gan9kb495().f[2]++;
  var toastId = (cov_gan9kb495().s[7]++, undefined);
  cov_gan9kb495().s[8]++;

  var onOpen = function onOpen() {
    cov_gan9kb495().f[3]++;
    // `getElementById` is called first because toastId might start with a number, which
    // causes querySelector(`#${toastID} button`) to fail
    var toastElement = (cov_gan9kb495().s[9]++, (cov_gan9kb495().b[1][0]++, toastId) && (cov_gan9kb495().b[1][1]++, document.getElementById(toastId)));
    var firstButton = (cov_gan9kb495().s[10]++, (cov_gan9kb495().b[2][0]++, toastElement) && (cov_gan9kb495().b[2][1]++, toastElement.querySelector('button')));
    cov_gan9kb495().s[11]++;

    if (firstButton) {
      cov_gan9kb495().b[3][0]++;
      cov_gan9kb495().s[12]++;
      firstButton.focus();
    } else {
      cov_gan9kb495().b[3][1]++;
    }
  };

  var toastOptions = (cov_gan9kb495().s[13]++, _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.toastOptions), {}, {
    autoClose: (cov_gan9kb495().b[4][0]++, options === null || options === void 0 ? void 0 : (_options$toastOptions = options.toastOptions) === null || _options$toastOptions === void 0 ? void 0 : _options$toastOptions.autoClose) || (cov_gan9kb495().b[4][1]++, false)
  }));
  cov_gan9kb495().s[14]++;
  toastId = toast(function (_ref2) {
    var closeToast = _ref2.closeToast;
    cov_gan9kb495().f[4]++;
    cov_gan9kb495().s[15]++;
    return /*#__PURE__*/React.createElement(React.Fragment, null, content, /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "flex-end"
    }, (cov_gan9kb495().b[5][0]++, options === null || options === void 0 ? void 0 : options.actions) && (cov_gan9kb495().b[5][1]++, options.actions.map(function (action, i) {
      cov_gan9kb495().f[5]++;
      cov_gan9kb495().s[16]++;
      return /*#__PURE__*/React.createElement(ToastButton, {
        key: i,
        actionText: action.actionText,
        onClick: action.onClick,
        analyticsName: "".concat(analyticsName, "-").concat(action.actionText.toLowerCase().split(' ').join('-')),
        "aria-label": action['aria-label']
      });
    })), (cov_gan9kb495().b[6][0]++, !toastOptions.autoClose) && (cov_gan9kb495().b[6][1]++, /*#__PURE__*/React.createElement(ToastButton, {
      actionText: "Close",
      onClick: closeToast,
      analyticsName: "".concat(analyticsName, "-close"),
      "aria-label": 'aria-label' in toastOptions ? (cov_gan9kb495().b[7][0]++, toastOptions['aria-label']) : (cov_gan9kb495().b[7][1]++, '')
    }))));
  }, _objectSpread({
    closeButton: false,
    // do not use the built-in Close button
    style: {
      backgroundColor: type === 'info' ? (cov_gan9kb495().b[8][0]++, colors.neutrals100) : (cov_gan9kb495().b[8][1]++, colors.red50),
      boxShadow: shadows.z2,
      color: colors.neutrals0,
      fontFamily: fonts.sans,
      fontSize: fontSizesNamedWithUnits.s1,
      fontWeight: fontWeights.normal,
      lineHeight: lineHeightsWithUnits.s1,
      margin: 0,
      paddingBlock: spaceWithUnits[5],
      paddingInline: spaceWithUnits[7]
    },
    onOpen: onOpen
  }, toastOptions));
};
export default Toast;